import { fromJS } from "immutable";

import TYPE from "../../constants/type";

// [VinUni] Quản lý đề tài
const initialState = fromJS({
  list: [],
  total: 0,
  detail: null,
  dashboard: null,
  isFetching: false,
  isSubmitting: false,
});

export default function researchTopicReducer(state = initialState, action) {
  switch (action.type) {
    case TYPE.RESEARCH_TOPIC.GET_ALL_LOADING:
    case TYPE.RESEARCH_TOPIC.FILTER_LOADING:
    case TYPE.RESEARCH_TOPIC.GET_BY_ID_LOADING:
    case TYPE.RESEARCH_TOPIC.DASHBOARD_LOADING:
      return state.merge({ isFetching: true });

    case TYPE.RESEARCH_TOPIC.GET_ALL_FAILURE:
    case TYPE.RESEARCH_TOPIC.FILTER_FAILURE:
    case TYPE.RESEARCH_TOPIC.GET_BY_ID_FAILURE:
    case TYPE.RESEARCH_TOPIC.DASHBOARD_FAILURE:
      return state.merge({ isFetching: false });

    case TYPE.RESEARCH_TOPIC.GET_ALL_SUCCESS:
      return state.merge({ list: action.payload ?? [], isFetching: false });

    case TYPE.RESEARCH_TOPIC.FILTER_SUCCESS:
      return state.merge({
        list: action.payload ?? [],
        total: action.total ?? 0,
        isFetching: false,
      });

    case TYPE.RESEARCH_TOPIC.GET_BY_ID_SUCCESS:
      return state.merge({ detail: action.payload ?? null, isFetching: false });

    case TYPE.RESEARCH_TOPIC.DASHBOARD_SUCCESS:
      return state.merge({ dashboard: action.payload ?? null, isFetching: false });

    case TYPE.RESEARCH_TOPIC.SUBMITTING_LOADING:
      return state.merge({ isSubmitting: true });

    case TYPE.RESEARCH_TOPIC.SUBMITTING_DONE:
      return state.merge({ isSubmitting: false });

    default:
      return state;
  }
}
